
/**
 * 获取路径上的对应语言
 */
export const getUrlLocale = () => {
    const match = window.location.pathname.match(/\/([a-z]*)\//)
    if (match === null) {
      return null;
    }
    const locale = match[1]
    if (locale) {
      return locale
    }
    return null
}